import { FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator = () => {
  return { isValid: true };
};
